import { AppRoutePath } from 'Pages/routes';

export const GetRequestAppointmentUrlV3 = (
  serviceProviderId: string,
  serviceOfferingUid: string,
) => {
  const path = AppRoutePath.APPOINTMENT_REQUEST_V3_CUSTOMER_INPUTS
    .replace('[serviceProviderId]', serviceProviderId)
    .replace('[serviceOfferingUid]', serviceOfferingUid);

  return path;
};

